import { Operation } from '@apollo/client';
import isAdminOperation from './isAdminOperation';

// A replay duplicates work, reuses a one-time token, or resends a current password that a
// successful first attempt already replaced
const neverRetried = new Set([
  'createExportClipToLibraryJob',
  'rerunJob',
  'resetPassword',
  'updateUserCredentials',
]);
// Temporary workaround to stop retries on importPodcastRss, as it would create duplicate entries
const notRetriedOnFetchFailure = new Set(['importPodcastRss', 'captivatePublish']);

export default function shouldRetryOperation(error: any, operation: Operation) {
  if (neverRetried.has(operation.operationName)) return false;
  // Off the IP allowlist, the load balancer's 403 surfaces as 'Failed to fetch'; fail fast.
  if (isAdminOperation(operation)) return false;
  return Boolean(
    (error?.message?.includes('Failed to fetch') &&
      !notRetriedOnFetchFailure.has(operation.operationName)) ||
    error?.message?.toLowerCase().includes('502 bad gateway'),
  );
}
